import styles from './souvenir.module.scss'
import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import noimage from 'assets/img/noimage.jpg'
import parse from 'html-react-parser'

//antd
import { Switch, Input, Row, Col, notification, Table, Popover, Button, Popconfirm } from 'antd'

//icons
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons'

//components
import { compare, formatCash } from 'utils'
import FilterDate from 'components/filter-date'
import SouvenirForm from './souvenir-form'

//apis
import { getSouvenirs, updateSouvenir, deleteSouvenir } from 'apis/souvenir'
import { getCountries } from 'apis/country'
import { getRegions } from 'apis/region'
import { getTaxList } from 'apis/tax'

export default function Souvenir() {
  const typingTimeoutRef = useRef(null)

  const [loading, setLoading] = useState(false)
  const [store, setStore] = useState([])
  const [countStore, setCountStore] = useState(0)
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: 20 })
  const [countries, setCountries] = useState([])
  const [regions, setRegions] = useState([])
  const [valueSearch, setValueSearch] = useState('')
  const [taxList, setTaxList] = useState([])

  const onSearch = (e) => {
    setValueSearch(e.target.value)
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      const value = e.target.value
      if (value) paramsFilter.name = value
      else delete paramsFilter.name

      paramsFilter.page = 1
      setParamsFilter({ ...paramsFilter })
    }, 750)
  }

  const _updateSouvenir = async (body, id) => {
    try {
      setLoading(true)
      const res = await updateSouvenir(body, id)
      if (res.status === 200) {
        if (res.data.success) {
          _getSouvenirs()
          notification.success({ message: 'Cập nhật quà lưu niệm thành công!' })
        } else
          notification.error({
            message: res.data.message || 'Cập nhật quà lưu niệm thất bại, vui lòng thử lại!',
          })
      } else
        notification.error({
          message: res.data.message || 'Cập nhật quà lưu niệm thất bại, vui lòng thử lại!',
        })
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const _getTaxList = async () => {
    try {
      const res = await getTaxList({ is_apply_order: false })
      if (res.status === 200) {
        setTaxList(res.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const _getSouvenirs = async () => {
    try {
      setLoading(true)
      const res = await getSouvenirs({ ...paramsFilter, is_souvenir: true })
      console.log(res)
      if (res.status === 200) {
        setStore(res.data.data)
        setCountStore(res.data.count)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const _getRegions = async () => {
    try {
      const res = await getRegions()
      if (res.status === 200) setRegions(res.data.data)
    } catch (error) {}
  }

  const _getCountries = async () => {
    try {
      const res = await getCountries()
      if (res.status === 200) setCountries(res.data.data)
    } catch (error) {}
  }

  const _deleteSouvenir = async (id) => {
    try {
      setLoading(true)
      const res = await deleteSouvenir([id])
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: 'Xoá quà lưu niệm thành công!' })
          _getSouvenirs({ ...paramsFilter })
        } else
          notification.error({
            message: res.data.message || 'Xoá quà lưu niệm thất bại, vui lòng thử lại!',
          })
      } else
        notification.error({
          message: res.data.message || 'Xoá quà lưu niệm thất bại, vui lòng thử lại!',
        })
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const contentImage = (data) => (
    <img src={data} style={{ width: '25rem', height: '15rem', objectFit: 'contain' }} alt="" />
  )
  const columns = [
    {
      title: 'STT',
      render: (text, record, index) => (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
      width: 20,
    },
    {
      title: 'Tên quà lưu niệm',
      render: (text, record) => (
        <SouvenirForm
          taxList={taxList}
          countries={countries}
          regions={regions}
          infoBranch={record}
          reloadData={_getSouvenirs}
        >
          <a>{record.name}</a>
        </SouvenirForm>
      ),
      sorter: (a, b) => compare(a, b, 'code'),
    },
    {
      title: 'Hình ảnh',
      dataIndex: 'image_urls',
      render: (text, record) =>
        text ? (
          <Popover content={() => contentImage(text)}>
            <div>
              <img src={text} style={{ width: 70, height: 70, objectFit: 'cover' }} alt="" />
            </div>
          </Popover>
        ) : (
          <img
            src={noimage}
            style={{ width: '6.75rem', height: '5rem', objectFit: 'cover' }}
            alt=""
          />
        ),
    },
    {
      title: 'Giới thiệu',
      width: 300,
      render: (text, record) => (record.description ? parse(record.description) : ''),
    },
    {
      title: 'Ưu tiên',
      dataIndex: 'priority',
      sorter: (a, b) => compare(a, b, 'priority'),
    },
    {
      title: 'Giá tiền',
      dataIndex: 'display_prices',
      render: (text, record) => (
        <div>
          {formatCash(
            record.display_prices && record.display_prices.length !== 0 && record.display_prices[0]
          )}
        </div>
      ),
      sorter: (a, b) => compare(a, b, 'phone'),
    },
    {
      title: 'Thuế',
      render: (text, record) =>
        record.tax_infos && record.tax_infos.map((tax) => tax.name).join(', '),
    },
    {
      title: 'Ngày tạo',
      dataIndex: 'create_date',
      render: (text, record) => (text ? moment(text).format('DD-MM-YYYY HH:mm') : ''),
      sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
    },
    {
      title: 'Trạng thái',
      dataIndex: 'is_active',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <Switch
          checked={record.is_active}
          onChange={(checked) => _updateSouvenir({ is_active: checked }, record.product_id)}
        />
      ),
    },
    {
      title: 'Hành động',
      width: 100,
      render: (text, record) => (
        <Popconfirm
          onConfirm={() => _deleteSouvenir(record.product_id)}
          title="Bạn có muốn xóa quà lưu niệm này không?"
        >
          <Button icon={<DeleteOutlined />} type="primary" danger />
        </Popconfirm>
      ),
    },
  ]

  const onClickClear = async () => {
    setParamsFilter({ page: 1, page_size: 20 })
    setValueSearch('')
    // setValueDateFilter(null)
  }

  useEffect(() => {
    _getSouvenirs()
    _getRegions()
    _getCountries()
    _getTaxList()
  }, [paramsFilter])

  return (
    <div className={`${styles['souvenir_manager']} ${styles['card']}`}>
      <Row
        wrap={false}
        align="middle"
        justify="space-between"
        style={{ borderBottom: '1px solid rgb(236, 226, 226)', paddingBottom: '0.75rem' }}
      >
        <div style={{ fontWeight: '600', fontSize: '1.2rem' }}>Quản lý quà lưu niệm</div>
        <SouvenirForm
          taxList={taxList}
          countries={countries}
          regions={regions}
          reloadData={_getSouvenirs}
        >
          <Button size="large" type="primary" icon={<PlusCircleOutlined />}>
            Thêm quà lưu niệm
          </Button>
        </SouvenirForm>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 10 }}>
        <Col xs={24} sm={24} md={11} lg={11} xl={7}>
          <Input
            size="large"
            style={{ width: '100%' }}
            name="name"
            value={valueSearch}
            enterButton
            onChange={onSearch}
            placeholder="Tìm kiếm theo mã, theo tên"
            allowClear
          />
        </Col>
        <Col xs={24} sm={24} md={11} lg={11} xl={7}>
          {/* <RangePicker
            size="large"
            className="br-15__date-picker"
            value={valueDateFilter}
            style={{ width: '100%' }}
            ranges={{
              Today: [moment(), moment()],
              'This Month': [moment().startOf('month'), moment().endOf('month')],
            }}
            onChange={onChangeDate}
          /> */}
          <FilterDate
            size="large"
            width={270}
            paramsFilter={paramsFilter}
            setParamsFilter={setParamsFilter}
          />
        </Col>
      </Row>
      <Row
        justify="end"
        style={{ marginTop: 15, display: Object.keys(paramsFilter).length < 3 && 'none' }}
      >
        <Button onClick={onClickClear} type="primary" size="large" danger>
          Xóa tất cả lọc
        </Button>
      </Row>

      <Table
        size="small"
        rowKey="_id"
        loading={loading}
        columns={columns}
        dataSource={store}
        style={{ width: '100%', marginTop: 20 }}
        pagination={{
          position: ['bottomLeft'],
          current: paramsFilter.page,
          pageSize: paramsFilter.page_size,
          pageSizeOptions: [20, 30, 40, 50, 70, 100],
          showQuickJumper: true,
          onChange: (page, pageSize) =>
            setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
          total: countStore,
        }}
      />
    </div>
  )
}
